import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useWishlist } from '../context/WishlistContext';
import { Plus, Heart } from 'lucide-react';

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const { isWishlisted, toggle } = useWishlist();
  const onAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // For products with variants, first variant is default; user can pick on PDP.
    const defaultVariant = product.variants ? product.variants[0] : null;
    addItem(product, 1, defaultVariant);
  };
  const onHeart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(product.id);
  };
  const onSale = product.compareAtPrice && product.compareAtPrice > product.price;
  const wished = isWishlisted(product.id);

  return (
    <Link to={`/products/${product.id}`} className="product-card group block">
      <div className="relative overflow-hidden bg-[#efe9db] aspect-[4/5]">
        <img
          src={product.images[0]}
          alt={product.title}
          className="product-card-image absolute inset-0 w-full h-full object-contain p-3"
          loading="lazy"
        />
        {product.images[1] && (
          <img
            src={product.images[1]}
            alt=""
            className="absolute inset-0 w-full h-full object-contain p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
            loading="lazy"
          />
        )}
        {onSale && <span className="badge-sale absolute top-3 left-3 z-10">Sale</span>}
        <button
          onClick={onHeart}
          aria-label="Toggle wishlist"
          className={`absolute top-3 right-3 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-[#faf7f1]/90 border border-[#c9c1ad] transition-colors ${wished ? 'text-[#7a3b2e]' : 'text-[#2f2a24] hover:text-[#7a3b2e]'}`}
        >
          <Heart className={`w-4 h-4 ${wished ? 'fill-current' : ''}`} />
        </button>
        <button
          onClick={onAdd}
          className="absolute bottom-3 right-3 z-10 w-10 h-10 bg-[#faf7f1]/95 border border-[#c9c1ad] flex items-center justify-center hover:bg-[#3a4a3b] hover:text-[#faf7f1] transition-colors duration-300"
          aria-label="Add to cart"
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
      <div className="pt-4 text-center">
        <h3 className="font-serif-elegant text-lg text-[#2f2a24] mb-1">{product.title}</h3>
        <div className="text-sm">
          {onSale ? (
            <span>
              <span className="text-[#6f6a5f] line-through mr-2">${product.compareAtPrice.toFixed(2)}</span>
              <span className="text-[#7a3b2e] font-medium">${product.price.toFixed(2)}</span>
            </span>
          ) : (
            <span className="text-[#2f2a24] font-medium">${product.price.toFixed(2)}</span>
          )}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
